import capitalize from 'lodash/capitalize';
import { KNOWN_STATES } from './DevPanel.constants';
import type { DevToolStateFlags } from './DevPanel.types';

export const getLocalStorageKey = (key: string) => `iterable.homepage.devPanel.${key}`;

export const getDevToolStates = <S extends string>(state: S): DevToolStateFlags<S> => {
  const result = {} as DevToolStateFlags<S>;

  // Combine known states with the current state to support both standard and custom states
  for (const curr of [...Object.values(KNOWN_STATES), state]) {
    if (curr) {
      const key =
        `isDevTool${capitalize(curr) as Capitalize<typeof curr>}StateEnabled` as keyof DevToolStateFlags<S>;

      // Enable the flag only for the current state
      const value = state === curr;
      result[key] = value as DevToolStateFlags<S>[keyof DevToolStateFlags<S>];
    }
  }

  return result;
};
